/** Session flag: each browser tab has its own sessionStorage, so the notice shows again in a new tab until acknowledged in that tab. */
export const ACK_SESSION_KEY = "isAcknowledge";

export function readAcknowledgeSession() {
  try {
    return (
      typeof sessionStorage !== "undefined" &&
      sessionStorage.getItem(ACK_SESSION_KEY) === "true"
    );
  } catch {
    return false;
  }
}

export function writeAcknowledgeSession() {
  try {
    sessionStorage.setItem(ACK_SESSION_KEY, "true");
  } catch {
    // storage unavailable (e.g. private mode)
  }
}

/** Static copy shown in the site-wide acknowledgement dialog. */
export const ACKNOWLEDGEMENT_COPY = {
  title: "Important Notice",
  buttonText: "I Acknowledge and Agree",
  text:
    'IMPORTANT NOTICE\n\nFortify Portal, Inc. ("Fortify") is not registered under securities legislation in any jurisdiction of Canada and is relying on the exemption from the dealer registration requirement under National Instrument 45-110 Start-up Crowdfunding Registration and Prospectus Exemptions.\n\nFortify will not, and is not authorized to, provide advice about the suitability or merits of any investment or security available on this platform. All investment decisions are yours alone.\n\nBy clicking "I Acknowledge and Agree," you confirm that you have read and understood this notice.',
};
